import styled, { css } from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

interface DotProps {
  active: boolean
}

export const Dots = styled.div`
  display: flex;
  position: absolute;
  top: 15px;
  right: 15px;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    top: auto;
    right: 50%;
    bottom: 30px;
  }
`

export const Dot = styled.div<DotProps>`
  ${({ active }) => css`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${active ? tokens.colors.primary : tokens.colors.black2};
    margin-right: 10px;
  `};
`
